import styled from 'styled-components';

import { IOverlayProps } from '.';

type TOverlayProps = Pick<IOverlayProps, 'align' | 'justify' | '$opacity' | '$zIndex'>;
type TOverlayContentProps = Pick<IOverlayProps, 'fullWidth' | 'fullHeight'>;

export const Overlay = styled.div<TOverlayProps>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: ${({ $zIndex }) => $zIndex};
    background: rgba(0, 0, 0, ${({ $opacity }) => $opacity});
    overflow: auto;
    overflow-x: hidden;
    cursor: pointer;
    border-radius: inherit;
    display: flex;
    justify-content: ${({ justify }) => justify};
    align-items: ${({ align }) => align};

    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */

    &::-webkit-scrollbar {
      display: none;
    }
`;

export const OverlayContent = styled.div<TOverlayContentProps>`
    display: contents;
    outline: none;
    pointer-events: auto;
    width: ${({ fullWidth }) => fullWidth ? '100%' : 'auto'};
    height: ${({ fullHeight }) => fullHeight ? '100%' : 'auto'};
`;
